<template>
  <div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap>
        <app-card :fullBlock="true" colClasses="xs12">
          <v-card-title>
            
            <v-spacer></v-spacer>

            <v-text-field
              append-icon="search"
              hide-details
              :label="$t('message.search')"
              single-line
              v-model="search"
            ></v-text-field>
          </v-card-title>

          <v-data-table :headers="headers" :pagination.sync="pagination" :items="linkedStores" :search="search">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">{{ $t(`message.${props.header.text}`) }}</span>
                <span>{{ $t(`message.${props.header.text}`) }}</span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-center">{{ props.item.store.name }}</td>
              <td class="text-center">{{ `${props.item.pendingToPayDelivery} $` }}</td>
              <td class="text-center">{{ `${props.item.pendingToPayStore} $` }}</td>
              <td class="text-center">{{ props.item.store.total_clients }} </td>
              <td class="text-center">{{ props.item.store.total_sales }} </td>
              <td class="text-center">
                <v-chip
                  v-if="props.item.allow_payment_to_delivery"
                  color="light-green accent-4"
                  outline
                >{{ $t('message.enabled') }}</v-chip>

                <v-chip v-else outline color="error">{{ $t('message.disabled') }}</v-chip>
              </td>
            </template>
          </v-data-table>
<!-- 
          <delete-confirmation-dialog
            @onConfirm="deleteDealer"
            :heading="$t('message.deleteConfirmation')"
            :message="$t('message.deleteMessage')"
            ref="deleteConfirmationDialog"
          ></delete-confirmation-dialog> -->
        </app-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import {
  GET_LINKED_STORES,
} from "../../../store/modules/delivery/company/actions.type";

export default {
  name: "linkedStores",
  data() {
    return {
      headers: [
        { text: "name", align: "center", sortable: true, value: "store.name" },
        { text: "pendingToCharge", sortable: true, align: "center", value: "pendingToPayDelivery" },
        { text: "pendingToPay", sortable: true, align: "center", value: "pendingToPayStore" },
        { text: "totalCustomers", align: "center", sortable: true, value: "store.total_clients" },
        { text: "totalSales", align: "center", sortable: true, value: "store.total_sales" },
        {
          text: "permissionToCharge",
          sortable: true,
          value: "allow_payment_to_delivery",
          align: "center"
        },
      ],
      search: "",
       pagination: {
        descending: true,
        sortBy: "store.name",
        rowsPerPage: 5
      },
    };
  },
  computed: {
    ...mapGetters(["linkedStores"])
  },
  created() {
    this.getLinkedStores();
  },
  methods: {
    getLinkedStores() {
      this.$store.dispatch(GET_LINKED_STORES);
    },
  }
};
</script>

<style>
</style>
